import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { CASES } from "@/data/content";

const CaseCard = ({ item, delay }) => {
  const isLarge = item.size === "large";
  return (
    <Reveal
      delay={delay}
      className={isLarge ? "md:col-span-7" : "md:col-span-5"}
    >
      <div
        className="group relative rounded-2xl clip-corner overflow-hidden border border-white/10 h-full min-h-[420px] flex flex-col justify-end transition-all duration-500 hover:border-[#00D2D3]/40"
        data-testid={`case-card-${item.id}`}
      >
        <img
          src={item.image}
          alt={item.title}
          className="absolute inset-0 w-full h-full object-cover grayscale-[40%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/70 to-transparent" />

        {item.status && (
          <span className="absolute top-5 right-5 text-xs font-mono-accent uppercase tracking-widest text-[#00D2D3] border border-[#00D2D3]/40 bg-black/50 backdrop-blur-sm rounded-full px-3 py-1">
            {item.status}
          </span>
        )}

        <div className="relative z-10 p-6 sm:p-8">
          <p className="text-xs font-mono-accent uppercase tracking-widest text-[#00D2D3] mb-2">
            {item.client}
          </p>
          <h3 className="font-outfit font-bold text-2xl sm:text-3xl text-white tracking-tight mb-3 group-hover:translate-x-1 transition-transform duration-500">
            {item.title}
          </h3>
          <p className="text-white/60 font-manrope text-sm leading-relaxed mb-5 max-w-md">
            {item.description}
          </p>

          {item.result && (
            <p className="text-sm font-manrope text-white/80 border-t border-white/10 pt-4 mt-2">
              <span className="text-[#00D2D3] font-semibold">Resultado:</span>{" "}
              {item.result}
            </p>
          )}

          {item.url && (
            <a
              href={`https://${item.url}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 mt-4 text-sm font-manrope font-medium text-white hover:text-[#00D2D3] transition-colors"
              data-testid={`case-card-link-${item.id}`}
            >
              {item.url}
              <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          )}
        </div>
      </div>
    </Reveal>
  );
};

const Cases = () => {
  return (
    <section
      id="cases"
      className="relative py-24 lg:py-32 max-w-7xl mx-auto px-6 lg:px-10"
      data-testid="cases-section"
    >
      <Reveal>
        <p className="font-mono-accent text-xs text-[#00D2D3] tracking-[0.25em] uppercase mb-4">
          Cases
        </p>
        <h2 className="font-outfit font-bold text-3xl sm:text-4xl text-white max-w-2xl tracking-tight">
          Projetos reais, entregues no prazo, em produção.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-6">
        {CASES.map((item, i) => (
          <CaseCard item={item} delay={i * 0.08} key={item.id} />
        ))}
      </div>
    </section>
  );
};

export default Cases;
